// packages/content/src/strings/items.ts (M1-T01) — pocket/storage UI words and tool/paper item names
import type { StringBank } from '../schema/strings';
export default {
  pockets: 'Pockets', storage: 'Storage', hand: 'In your hands', empty: 'Nothing here yet.',
  drop: 'Drop', release: 'Let it go', hold: 'Hold', unhold: 'Put it away', toStorage: 'Send to storage', toPockets: 'Take to pockets',
  qty: '×{n}', sellsFor: 'Sells for {price:num} {price|currency}', noSale: "The shop won't take this.",
  tool: 'Tool', noTool: 'Hands free', rod: 'Fishing rod', shovel: 'Shovel',
  stationery: 'Plain stationery', wrapping: 'Wrapping paper',
  storageAtHome: 'Your storage is at home.', handFirst: 'Deal with what you are holding first.',
  pickHint: 'Tap something in your pockets to see what you can do with it.',                       // M1-P1: the empty detail column
  plantHint: 'To plant it, close your pockets, face an empty patch of grass and press A.',          // M1-P1: a selected fruit
} as const satisfies StringBank;
